import React from "react";
import styled from "styled-components";
import MCPGuideCard from "~/components/MCPGuideCard";
import useAbacExt from "~/hooks/abac";
import { AuthoritiesEnum } from "~/types/enums";
const Wrapper = styled.aside`
  display: flex;
  flex-direction: column;
  position: relative;
`;
const IntegrationsSidebar = () => {
  const {
    userHas
  } = useAbacExt();
  return /*#__PURE__*/React.createElement(Wrapper, null, userHas(AuthoritiesEnum.AI_ASSISTANT_READ) && /*#__PURE__*/React.createElement(MCPGuideCard, {
    s: {
      p: 0
    }
  }));
};
export default IntegrationsSidebar;